'use strict';

bbw.directive.bindUnsafe = function() {
    return {
        scope: {
            value: '=bindUnsafe'
        },
        link: function(scope, element) {
            function update(input) {
                element.html(input || '');
            }

            scope.$watch('value', update);
            update(scope.value);
        }
    }
};
